import { BrowserUtil } from '../BrowserUtil';
import { NodeJSUtil } from '../NodeJSUtil';
import { EnvUtil } from '../EnvUtil';
import AppConfigService from './AppConfigService';
import { getServerHost } from '../config/getServerHost';
const nodeEnv = NodeJSUtil.getNodeEnv() || 'dev';
const appConfig = AppConfigService.appConfig();
export default class AppService {
    static serverHost() {
        return getServerHost();
    }
    static cloudServerHost() {
        const env = EnvUtil.getAppEnv();
        let serverUrl = 'https://dx.local.aperza.com:18010';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://dx.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://dx.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://dx.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://dx.aperza.com';
        }
        return serverUrl;
    }
    static wwwServerHost() {
        const env = EnvUtil.getAppEnv();
        let serverUrl = 'https://www.local.aperza.com:8280';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://www.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://www.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://www.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://www.aperza.com';
        }
        return serverUrl;
    }
    static ecServerHost() {
        const env = EnvUtil.getAppEnv();
        let serverUrl = 'https://ec.local.aperza.com:8081';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://ec.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://ec.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://ec.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://ec.aperza.com';
        }
        return serverUrl;
    }
    static orderServerHost() {
        const env = EnvUtil.getAppEnv();
        let serverUrl = 'https://order.test.aperza.com';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://order.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://order.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://order.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://order.aperza.com';
        }
        return serverUrl;
    }
    static businessServerHost() {
        const env = EnvUtil.getAppEnv();
        let serverUrl = 'https://business.test.aperza.com';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://business.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://business.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://business.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://business.aperza.com';
        }
        return serverUrl;
    }
    static tvServerHost() {
        const env = EnvUtil.getAppEnv();
        let serverUrl = 'https://tv.local.aperza.com:8050';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://tv.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://tv.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://tv.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://tv.aperza.com';
        }
        return serverUrl;
    }
    static newsServerHost() {
        const env = EnvUtil.getAppEnv();
        let serverUrl = 'https://news.test.aperza.jp'; // make local/test is same
        if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://news.test.aperza.jp';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://news.stg.aperza.jp';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://news.aperza.jp';
        }
        return serverUrl;
    }
    static staticServerHost() {
        const env = EnvUtil.getAppEnv();
        let serverUrl = 'https://static.test.aperza.com'; // make local/test is same
        if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://static.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://static.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://static.aperza.com';
        }
        return serverUrl;
    }
    static trApiServerHost() {
        const env = EnvUtil.getAppEnv();
        let serverUrl = 'https://tr.api.test.aperza.com'; // make local/test is same
        if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://tr.api.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://tr.api.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://tr.api.aperza.com';
        }
        return serverUrl;
    }
    static mailApiServerHost() {
        const env = EnvUtil.getAppEnv();
        let serverUrl = 'https://mail-api.test.aperza.com'; // make local/test is same
        if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://mail-api.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://mail-api.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://mail-api.aperza.com';
        }
        return serverUrl;
    }
    static accountServerHost() {
        const env = EnvUtil.getAppEnv();
        let serverUrl = 'https://account.test.aperza.com';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://account.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://account.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://account.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://account.aperza.com';
        }
        return serverUrl;
    }
    static idServerHost() {
        const env = EnvUtil.getAppEnv();
        let serverUrl = 'https://id.test.aperza.com';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://id.test.aperza.com';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://id.test2.aperza.com';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://id.stg.aperza.com';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://id.aperza.com';
        }
        return serverUrl;
    }
    static cluezMemberHost() {
        const env = EnvUtil.getAppEnv();
        let serverUrl = 'https://member.test.cluez.biz';
        if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://member.test.cluez.biz';
        }
        else if (env === EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://member.test2.cluez.biz';
        }
        else if (env === EnvUtil.ENV_STG) {
            serverUrl = 'https://member.stg.cluez.biz';
        }
        else if (env === EnvUtil.ENV_PROD) {
            serverUrl = 'https://member.cluez.biz';
        }
        return serverUrl;
    }
    static isDevelopment() {
        return nodeEnv === 'dev';
    }
    static isErrorPage() {
        const pathName = BrowserUtil.getPath();
        return pathName.indexOf('error') > -1;
    }
    static isMainPage() {
        const pathName = BrowserUtil.getPath();
        return (pathName === '/' ||
            pathName === '/en' ||
            pathName === '/en/' ||
            pathName.startsWith('/en/?') ||
            pathName === '/ja' ||
            pathName === '/ja/' ||
            pathName.startsWith('/ja/?'));
    }
    static staticUrl(path) {
        const host = appConfig.cdnHost;
        return `${host}${path}`;
    }
    static staticUrlWithProtocol(path) {
        const host = appConfig.cdnHost;
        return `https:${host}${path}`;
    }
    static encodedPath() {
        let encodedPath = '';
        // https://aperza.atlassian.net/browse/AB-5120
        // Exception for order
        if (appConfig.serviceType === 'aperza-order') {
            return encodedPath;
        }
        const path = (BrowserUtil.getPath() + BrowserUtil.getSearch()).replace(/^\/+/, '');
        if (path !== '/') {
            encodedPath = encodeURIComponent(path);
        }
        return encodedPath;
    }
    static checkEncodedPath() {
        // https://aperza.atlassian.net/browse/AB-20616
        // add encodedPath if the path NOT exists
        // avoid duplicate encodedPath on multiple attempt access on login page
        const urlParams = new URL(window.location.href).searchParams;
        if (urlParams.has('path')) {
            return urlParams.get('path');
        }
        return this.encodedPath();
    }
    static encodedPathParameter() {
        return `&path=${this.encodedPath()}`;
    }
    static appConfig() {
        return appConfig;
    }
}
export { AppService };
